module.exports = __webpack_public_path__ + "img/faq-search-filter.e44a1c37.jpg";